import { render } from "./MeMusic.vue?vue&type=template&id=5a91584a&scoped=true"
import script from "./MeMusic.vue?vue&type=script&lang=js"
export * from "./MeMusic.vue?vue&type=script&lang=js"

import "./MeMusic.vue?vue&type=style&index=0&id=5a91584a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a91584a"]])

export default __exports__